module.exports = __webpack_public_path__ + "img/banner_new.318f2779.jpg";